<arpio-center-panel>
  <div class="light-control-host">
    <h3 class="panel-title">Thanks for choosing {{ uiService.productName }} in the AWS Marketplace</h3>
    <div class="margin-top">
      If you are new to {{ uiService.productName }}, or would like to create an additional
      {{ uiService.productName }} account, choose "Create New Account."
    </div>
    <div class="flex-center-row">
      <div class="spacer"></div>
      <button class="arpio-button margin-top" (click)="newAccountClick()">Create New Account</button>
      <div class="spacer"></div>
    </div>
    <div class="margin-top">
      If you have an existing {{ uiService.productName }} account, and would like to associate your AWS Marketplace
      subscription with that account, choose "Link Existing Account."
    </div>
    <div class="flex-center-row">
      <div class="spacer"></div>
      <button class="arpio-button margin-top" (click)="existingAccountClick()">Link Existing Account</button>
      <div class="spacer"></div>
    </div>
  </div>
</arpio-center-panel>
